<template lang="">
    <div v-frag>
        <CardIeaAppMain>
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="11" outlined shaped class="mt-5">
                <v-card-title class="d-flex justify-left " style="word-break: keep-all !important;"> Cargar Archivos de Preinscipción</v-card-title>
                <v-card-text >
                    <v-container fluid>
                        <v-row >
                            <v-col cols="12" sm="12" xs='12' md="6" lg="6" xl="6">
                                <v-text-field v-model="dniAlumno" label="DNI" type="text" :disabled="disableDni"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" xs='12' md="6" lg="6" xl="6" v-if="nameRouter=='CargaArchivo'">
                                <v-btn color="success" elevation="7" large @click="buscarDatos()">
                                    Buscar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <!-- v-if="mostrarCampos==true" -->
                        <v-row :style="(mostrarCampos==true?'':'display:none;')">
                            <v-col cols="12" sm="12" xs='12' md="6" lg="3" xl="3">
                                <v-label >Frente DNI <span color="red">*</span> </v-label>

                                <vue-dropify id="img_frente_dni" class="mt-3" data-show-remove="false" :disabled="disableFrenteDNI" @change="changeFrenteDni()"  v-model="frenteDni" :src="urlFrenteDni"></vue-dropify>
                            </v-col>
                            <v-col cols="12"  sm="12" xs='12' md="6" lg="3" xl="3">
                                <v-label >Dorso DNI</v-label>
                                <vue-dropify id="img_anverso_dni" class="mt-3" :disabled="disableAnversoDNI" @change="changeAnversoDni()" v-model="anversoDni" :src="urlAnversoDni"></vue-dropify>
                            </v-col>
                            <v-col cols="12" sm="12" xs='12' md="6" lg="3" xl="3">
                                <v-label >Aceptación del Reglamento y/o Débito Automático</v-label>
                                <vue-dropify id="img_autorizacion" class="mt-3" :disabled="disableAutorizacion" @change="changeAutorizacion()" v-model="autorizacionDa" :src="urlAutorizacionDa"></vue-dropify>
                            </v-col>
                            <v-col cols="12" sm="12" xs='12' md="6" lg="3" xl="3">
                                <v-label >Comprobante de Pago</v-label>
                                <vue-dropify id="img_comprobante"  class="mt-3" :disabled="disableComprobante" @change="changeComprobante()" v-model="comprobante" :src="urlcomprobante"></vue-dropify>
                            </v-col>
                        </v-row>
                        <v-row :style="(mostrarCampos==true?'':'display:none;')">
                            <v-col cols="12" sm="12" xs='12' md="6" lg="3" xl="3" :style="((comprobante.length>0 || urlcomprobante!='')?'':'display:none;')" >
                                <v-label >Comprobante de Pago 2 (Opcional)</v-label>
                                <vue-dropify id="img_comprobante_2"  class="mt-3" :disabled="disableComprobante2" @change="changeComprobante2()" v-model="comprobante2" :src="urlcomprobante2"></vue-dropify>

                            </v-col>
                            <v-col cols="12" sm="12" xs='12' md="6" lg="3" xl="3" :style="displayComprobante3()" >
                                <v-label >Comprobante de Pago 3 (Opcional)</v-label>
                                <vue-dropify id="img_comprobante_3"  class="mt-3" :disabled="disableComprobante3" @change="changeComprobante3()" v-model="comprobante3" :src="urlcomprobante3"></vue-dropify>

                            </v-col>
                        </v-row>
                        <v-row :style="(mostrarCampos==true?'':'display:none;')">
                            <v-col cols="12" sm="12" xs='12' md="6" lg="6" xl="6">
                                <v-text-field type="email" v-model="email_sucripcion" label="Email de Suscripción" ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <v-textarea  v-model="comentario" label="Comentario"  rows="2" row-height="20">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>   
            <v-row align="center" class="mt-5">
                    <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6" v-if="dniAlumno!='' && mostrarCampos==true">
                        <v-btn color="success" elevation="7" large @click="guardarDatos()">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>             
            </v-col>
 
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import VueDropify from 'vue-dropify';
export default {
    components: {
        CardIeaAppMain,
        'vue-dropify': VueDropify
    },
    data() {
        return {
            dniAlumno: '',
            frenteDni: [],
            anversoDni: [],
            autorizacionDa: [],
            comprobante: [],
            comprobante2: [],
            comprobante3: [],
            preinscrito: null,
            urlFrenteDni: '',
            urlAnversoDni: '',
            urlAutorizacionDa: '',
            urlcomprobante: '',
            urlcomprobante2: '',
            urlcomprobante3: '',

            documentoInscripcion: null,
            nameRouter: '',
            mostrarBotonRedireccion: false,
            disableDni: false,
            mostrarMensajeConfirm: false,
            mostrarCampos: false,
            disableFrenteDNI: false,
            disableAnversoDNI: false,
            disableAutorizacion: false,
            disableComprobante: false,
            disableComprobante2: false,
            disableComprobante3: false,

            email_sucripcion: "",
            comentario: ""
        }
    },
    methods: {
        displayComprobante3() {
            if (this.comprobante.length > 0 || this.urlcomprobante != '') {
                if (this.comprobante2.length > 0 || this.urlcomprobante2 != '') {
                    return ''
                } else {
                    return 'display:none;'
                }
            } else {
                return 'display:none';
            }
        },
        changeFrenteDni() {
            this.urlFrenteDni = ''
        },
        changeAnversoDni() {
            this.urlAnversoDni = ''
        },
        changeAutorizacion() {
            this.urlAutorizacionDa = ''
        },
        changeComprobante() {
            this.urlcomprobante = ''
            console.log(this.comprobante)
        },
        changeComprobante2() {
            this.urlcomprobante2 = ''
        },
        changeComprobante3() {
            this.urlcomprobante3 = ''
        },
        async guardarDatos() {

            // if (this.documentoInscripcion) {
            if (this.documentoInscripcion == null) {
                alert("Tienes que empezar el proceso completando un circuito");
                return false;
            }
            if (this.frenteDni.length == 0 && this.anversoDni.length == 0 && this.comprobante.length == 0 && this.autorizacionDa.length == 0) {
                if (this.urlFrenteDni == "" && this.urlAnversoDni == "" && this.urlAutorizacionDa == "" && this.urlcomprobante == "") {
                    alert("Debes cargar al menos un documento")
                    return false;
                }

            }

            if (this.dniAlumno.trim().length == 0) {
                alert("Ingrese un dni correcto");
                return
            }

            // if (this.mostrarMensajeConfirm) {
            if ((this.frenteDni.length == 0 && this.urlFrenteDni == '') || (this.anversoDni.length == 0 && this.urlAnversoDni == '') || (this.comprobante.length == 0 && this.urlcomprobante == "") || (this.autorizacionDa.length == 0 && this.urlAutorizacionDa == '')) {
                let confirmacion = confirm('Está por enviar el formulario SIN todos los documentos necesarios, por ende, su usuario NO PODRÁ ser dado de alta. ¿Desea avanzar a pesar de ello?')

                if (confirmacion == false) {
                    return false;
                }
            }
            // }

            var formData = new FormData();
            if (this.documentoInscripcion) {
                formData.append('documentacion_id', this.documentoInscripcion.id);
            } else {
                formData.append('documentacion_id', 0);
            }
            formData.append('dni', this.dniAlumno);

            if (this.frenteDni.length > 0) {
                formData.append('frenteDni', this.frenteDni[0]);
            } else {
                formData.append('frenteDni', null);
            }

            if (this.anversoDni.length > 0) {
                formData.append('anversoDni', this.anversoDni[0]);
            } else {
                formData.append('anversoDni', null);
            }


            if (this.autorizacionDa.length > 0) {
                formData.append('autorizacionDa', this.autorizacionDa[0]);
            } else {
                formData.append('autorizacionDa', null);
            }

            if (this.comprobante.length > 0) {
                formData.append('comprobante', this.comprobante[0]);
            } else {
                formData.append('comprobante', null);
            }


            formData.append('urlFrenteDni', this.urlFrenteDni)
            formData.append('urlAnversoDni', this.urlAnversoDni)
            formData.append('urlAutorizacionDa', this.urlAutorizacionDa)
            formData.append('urlcomprobante', this.urlcomprobante)
            formData.append('email_sucripcion', this.email_sucripcion)
            formData.append('comentario', this.comentario)
            if (this.comprobante.length > 0 || this.urlcomprobante != '') {
                if (this.comprobante2.length > 0) {
                    formData.append('comprobante2', this.comprobante2[0])
                    formData.append('urlcomprobante2', this.urlcomprobante2)
                    if (this.comprobante3.length > 0) {
                        formData.append('comprobante3', this.comprobante3[0])
                        formData.append('urlcomprobante3', this.urlcomprobante3)
                    } else {
                        formData.append('comprobante3', null)
                        formData.append('urlcomprobante3', this.urlcomprobante3)
                    }

                } else {
                    if (this.urlcomprobante2 == '') {
                        formData.append('comprobante2', null)
                        formData.append('comprobante3', null)
                        formData.append('urlcomprobante3', '')
                        formData.append('urlcomprobante2', this.urlcomprobante2)
                    } else {
                        formData.append('comprobante2', null)
                        formData.append('urlcomprobante2', this.urlcomprobante2)
                        if (this.comprobante3.length > 0) {
                            formData.append('comprobante3', this.comprobante3[0])
                            formData.append('urlcomprobante3', this.urlcomprobante3)
                        } else {
                            formData.append('comprobante3', null)
                            formData.append('urlcomprobante3', this.urlcomprobante3)
                        }
                    }


                }
            } else {
                formData.append('comprobante2', null)
                formData.append('comprobante3', null)
                formData.append('urlcomprobante2', '')
                formData.append('urlcomprobante3', '')

            }

            let url = "preinscripcion/guardar-documentos";
            await this.$API
                .post({
                    url: url,
                    data: formData
                }).then((res) => {
                    console.log(res);
                    if (res.estado) {
                        alert(res.mensaje)

                        this.urlFrenteDni = ''
                        this.urlAnversoDni = ''
                        this.urlAutorizacionDa = ''
                        this.urlcomprobante = ''
                        this.frenteDni = []
                        this.anversoDni = []
                        this.comprobante = []
                        this.autorizacionDa = []
                        console.log(res)
                        if (res.redireccionar) {
                            location.href = res.url
                        }
                    } else {
                        alert(res.mensaje)
                    }
                });
            // }

        },
        loadInicial() {
            document.querySelectorAll(".vue-dropify__message").forEach(el => {
                el.innerHTML = "Carga tu archivo"
            })
            let app = this
            if (this.$route.params.id && this.$route.params.preinscrito) {
                this.disableDni = true;
                this.mostrarMensajeConfirm = true
                this.mostrarCampos = true
                app.$API
                    .post({
                        url: "circuito/cargar-datos",
                        data: {
                            preinscrito: this.$route.params.preinscrito,
                            circuito: this.$route.params.id
                        }
                    }).then(res => {
                        console.log(res)
                        app.preinscrito = res.preinscrito

                        app.dniAlumno = app.preinscrito.DNI
                        app.documentoInscripcion = res.documentos

                        app.urlFrenteDni = app.documentoInscripcion.url_frente_dni
                        app.urlAnversoDni = app.documentoInscripcion.url_anverso_dni
                        app.urlAutorizacionDa = app.documentoInscripcion.url_autorizacion_suscripcion
                        app.urlcomprobante = app.documentoInscripcion.url_comprobante
                    })
            }
        },
        async buscarDatos() {
            if (this.dniAlumno.trim().length == 0) {
                alert("Ingrese un dni correcto");
                return
            }
            let app = this
            let url = "preinscripcion/buscar-documentos";
            await this.$API
                .post({
                    url: url,
                    data: {
                        dni: this.dniAlumno
                    }
                }).then((res) => {
                    if (res.estado) {
                        this.mostrarCampos = true

                        app.preinscrito = res.preinscrito
                        // app.dniAlumno = app.preinscrito.DNI
                        app.documentoInscripcion = res.documentos
                        app.urlFrenteDni = (app.documentoInscripcion.url_frente_dni == null ? '' : app.documentoInscripcion.url_frente_dni)
                        app.urlAnversoDni = (app.documentoInscripcion.url_anverso_dni == null ? '' : app.documentoInscripcion.url_anverso_dni)
                        app.urlAutorizacionDa = (app.documentoInscripcion.url_autorizacion_suscripcion == null ? '' : app.documentoInscripcion.url_autorizacion_suscripcion)
                        app.urlcomprobante = (app.documentoInscripcion.url_comprobante == null ? '' : app.documentoInscripcion.url_comprobante)

                        app.urlcomprobante2 = (app.documentoInscripcion.url_comprobante_2 == null ? '' : app.documentoInscripcion.url_comprobante_2)
                        app.urlcomprobante3 = (app.documentoInscripcion.url_comprobante_3 == null ? '' : app.documentoInscripcion.url_comprobante_3)

                        app.email_sucripcion = (app.documentoInscripcion.email_sucripcion == null ? '' : app.documentoInscripcion.email_sucripcion)
                        app.comentario = (app.documentoInscripcion.comentario == null ? '' : app.documentoInscripcion.comentario)
                        if (app.documentoInscripcion.estado_frente_dni == 1) {
                            app.disableFrenteDNI = true;
                            document.getElementById("img_frente_dni").style.pointerEvents = "none"
                        } else {
                            app.disableFrenteDNI = false;
                            document.getElementById("img_frente_dni").style.pointerEvents = ""
                        }
                        if (app.documentoInscripcion.estado_anverso_dni == 1) {
                            app.disableAnversoDNI = true;
                            document.getElementById("img_anverso_dni").style.pointerEvents = "none"
                        } else {
                            app.disableAnversoDNI = false;
                            document.getElementById("img_anverso_dni").style.pointerEvents = ""
                        }

                        if (app.documentoInscripcion.estado_comprobante == 1) {
                            app.disableComprobante = true;
                            document.getElementById("img_comprobante").style.pointerEvents = "none"
                            document.getElementById("img_comprobante_2").style.pointerEvents = "none"
                            document.getElementById("img_comprobante_3").style.pointerEvents = "none"

                        } else {
                            app.disableComprobante = false;
                            document.getElementById("img_comprobante").style.pointerEvents = ""
                            document.getElementById("img_comprobante_2").style.pointerEvents = ""
                            document.getElementById("img_comprobante_3").style.pointerEvents = ""
                        }

                        if (app.documentoInscripcion.estado_autorizacion_suscripcion == 1) {
                            app.disableAutorizacion = true;
                            document.getElementById("img_autorizacion").style.pointerEvents = "none"
                        } else {
                            app.disableAutorizacion = false;
                            document.getElementById("img_autorizacion").style.pointerEvents = ""
                        }
                    } else {
                        if (this.mostrarCampos) {
                            document.getElementById("img_frente_dni").style.pointerEvents = ""
                            document.getElementById("img_anverso_dni").style.pointerEvents = ""
                            document.getElementById("img_comprobante").style.pointerEvents = ""
                            document.getElementById("img_autorizacion").style.pointerEvents = ""
                            document.getElementById("img_comprobante_2").style.pointerEvents = ""
                            document.getElementById("img_comprobante_3").style.pointerEvents = ""
                        }

                        app.disableFrenteDNI = false;
                        app.disableAnversoDNI = false;
                        app.disableComprobante = false;
                        app.disableAutorizacion = false;

                        app.preinscrito = null;
                        app.documentoInscripcion = null;
                        app.urlFrenteDni = '';
                        app.urlAnversoDni = '';
                        app.urlAutorizacionDa = '';
                        app.urlcomprobante = '';
                        app.frenteDni = []
                        app.anversoDni = []
                        app.comprobante = []
                        app.autorizacionDa = []
                        app.comentario = ''
                        app.email_sucripcion = ''
                        alert(res.mensaje)

                    }
                });
        }
    },
    mounted() {
        this.nameRouter = this.$route.name;
        this.loadInicial();
    }
}
</script>